import React from 'react';

export const MetricValueCell = ({ value }: { value: string }) => {
  const parsedValue: number = parseFloat(value);
  if (isNaN(parsedValue)) return <span>{value}</span>;
  return <span title={value}>{parseFloat(value).toFixed(4)}</span>;
};
